import { Pathname } from "./pathname";

export const PathnameGenerator = (name: string) => {
	return Pathname.DASHBOARD_INVENTORY + name;
};

export const itemsRoutes = {
	// inventory --------------------------------------------------------------------------
	ADD_INVENTORY_ITEM: '/product-management/items/add-inventory-item',
	EDIT_INVENTORY_ITEM: '/product-management/items/:id/edit-inventory-item',
	VIEW_INVENTORY_ITEM: '/product-management/items/:id/view-inventory-item',
	// non-inventory --------------------------------------------------------------------------
	ADD_NON_INVENTORY_ITEM: '/product-management/items/add-non-inventory-item',
	EDIT_NON_INVENTORY_ITEM: '/product-management/items/:id/edit-non-inventory-item',
	VIEW_NON_INVENTORY_ITEM: '/product-management/items/:id/view-non-inventory-item',
	// assembly -------------------------------------------------------------------------------
	ADD_ASSEMBLY_ITEM: '/product-management/items/add-assembly-item',
	EDIT_ASSEMBLY_ITEM: '/product-management/items/:id/edit-assembly-item',
	VIEW_ASSEMBLY_ITEM: '/product-management/items/:id/view-assembly-item',
	// service --------------------------------------------------------------------------------
	ADD_SERVICE_ITEM: '/product-management/items/add-service-item',
	EDIT_SERVICE_ITEM: '/product-management/items/:id/edit-service-item',
	VIEW_SERVICE_ITEM: '/product-management/items/:id/view-service-item',
	// package --------------------------------------------------------------------------------
	ADD_PACKAGE_ITEM: '/product-management/items/add-package-item',
	EDIT_PACKAGE_ITEM: '/product-management/items/:id/edit-package-item',
	VIEW_PACKAGE_ITEM: '/product-management/items/:id/view-package-item',
}

export const itemCategoryCRUDRoutes = {
	ADD_ITEM_CATEGORY: '/product-management/item-category/add-item-category',
	EDIT_ITEM_CATEGORY: '/product-management/item-category/:id/edit-item-category',
	VIEW_ITEM_CATEGORY: '/product-management/item-category/:id/view-item-category',
}
export const discountedItemCRUDRoutes = {
	ADD_DISCOUNTED_ITEM: '/product-management/discounted-items/add-discounted-items',
	VIEW_DISCOUNTED_ITEM: '/product-management/discounted-items/:id/view-discounted-items',
	EDIT_DISCOUNTED_ITEM: '/product-management/discounted-items/:id/edit-discounted-items',
}
export const attributeCrudRoutes = {
	ADD_ATTRIBUTES: '/configuration/attributes/add-attributes',
	EDIT_ATTRIBUTES: '/configuration/attributes/:id/edit-attributes',
	VIEW_ATTRIBUTES: '/configuration/attributes/:id/view-attributes',
}
export const locationCrudRoutes = {
	ADD_LOCATION: '/configuration/location/add-location',
	EDIT_LOCATION: '/configuration/location/:id/edit-location',
	VIEW_LOCATION: '/configuration/location/:id/view-location',
}
export const routeRulesCrudRoutes = {
	ADD_ROUTE_RULES: '/configuration/route-rules/add-route-rules',
	EDIT_ROUTE_RULES: '/configuration/route-rules/:id/edit-route-rules',
	VIEW_ROUTE_RULES: '/configuration/route-rules/:id/view-route-rules',
}
export const binsCrudRoutes = {
	ADD_BINS: '/configuration/bins/add-bins',
	EDIT_BINS: '/configuration/bins/:id/edit-bins',
	VIEW_BINS: '/configuration/bins/:id/view-bins',
}
export const uomCrudRoutes = {
	ADD_UOM: '/configuration/UOM/add-UOM',
	EDIT_UOM: '/configuration/UOM/:id/edit-UOM',
	VIEW_UOM: '/configuration/UOM/:id/view-UOM'
}
export const stockTrasnferCrudRoutes = {
	ADD_STOCK_TRANSFER: '/operations/stock-transfer/add-stock-transfer',
	EDIT_STOCK_TRANSFER: '/operations/stock-transfer/:id/edit-stock-transfer',
	VIEW_STOCK_TRANSFER: '/operations/stock-transfer/:id/view-stock-transfer',
}
export const binTrasnferCrudRoutes = {
	ADD_BIN_TRANSFER: '/operations/bin-transfer/add-bin-transfer',
	EDIT_BIN_TRANSFER: '/operations/bin-transfer/:id/edit-bin-transfer',
	VIEW_BIN_TRANSFER: '/operations/bin-transfer/:id/view-bin-transfer',
}
export const scrapCrudRoutes = {
	ADD_SCRAP: '/operations/scrap/add-scrap',
	EDIT_SCRAP: '/operations/scrap/:id/edit-scrap',
	VIEW_SCRAP: '/operations/scrap/:id/view-scrap',
}
export const inventoryAdjustmentCrudRoutes = {
	ADD_INVENTORY_ADJUSTMENT: '/operations/inventory-adjustment/add-inventory-adjustment',
	EDIT_INVENTORY_ADJUSTMENT: '/operations/inventory-adjustment/:id/edit-inventory-adjustment',
	VIEW_INVENTORY_ADJUSTMENT: '/operations/inventory-adjustment/:id/view-inventory-adjustment',
}

const productManagement = {
	ITEM: '/product-management/items',
	...itemsRoutes,
	PACKAGED_ITEM: '/product-management/packaged-item',

	ITEM_CATEGORY: '/product-management/item-category',
	...itemCategoryCRUDRoutes,

	DISCOUNTED_ITEM: '/product-management/discounted-item',
	...discountedItemCRUDRoutes
};

const PATHNAME_CONFIGURATION = {
	ATTRIBUTES: '/configuration/attributes',
	...attributeCrudRoutes,
	LOCATION: '/configuration/location',
	...locationCrudRoutes,
	ROUTE_RULES: '/configuration/route-rules',
	...routeRulesCrudRoutes,
	BINS: '/configuration/bins',
	...binsCrudRoutes,
	UOM: '/configuration/uom',
	...uomCrudRoutes
};

const PATHNAME_OPERATIONS = {
	STOCK_TRANSFER: '/operations/stock-transfer',
	...stockTrasnferCrudRoutes,
	BIN_TRANSFER: '/operations/bin-transfer',
	...binTrasnferCrudRoutes,
	SCRAP: '/operations/scrap',
	...scrapCrudRoutes,
	INVENTORY_ADJUSTMENT: '/operations/inventory-adjustment',
	...inventoryAdjustmentCrudRoutes
};

const sales = {};
const purchase = {};
const reports = {
	REPORTS: '/reports',
	STOCK_STATUS: '/reports/stock-status',
	REORDER:'/reports/reorder',
	EXPIRY_DATE: '/reports/expiry-date',
	STOCK_MOVEMENT: '/reports/stock-movement',
	INVENTORY_VALUATION: '/reports/inventory-valuation',
	INVENTORY_VALUATION_DETAIL: '/reports/inventory-valuation-detail',
	// New inventory reports
	STOCK_RECONCILIATION: '/reports/stock-reconciliation',
	SLOW_MOVING_INVENTORY: '/reports/slow-moving-inventory',
	WAREHOUSE_STOCK_AGING: '/reports/warehouse-stock-aging',
	WAREHOUSE_TRANSFERS: '/reports/warehouse-transfers',
	RETURN_TO_VENDOR: '/reports/return-to-vendor',
	INVENTORY_AGING: '/reports/inventory-aging',
	INVENTORY_COST_ANALYSIS: '/reports/inventory-cost-analysis',
	STOCK_MOVEMENT_TURNOVER: '/reports/stock-movement-turnover',
	STOCK_ON_HAND: '/reports/stock-on-hand',
	STOCK_RESERVATION: '/reports/stock-reservation',
	SETTINGS: '/settings',
	FORMS: "/settings/forms",
	CUSTOM_FORM: "/settings/forms/custom-form",
	INVENTORY_SETTINGS: "/settings/inventory-settings",
	SCHEDULE_REPORT: '/reports/schedule-report',
};

export const PathnameInventory = {
	LANDING_PAGE: '/',
	LIST: '/list',
	PRODUCT_MANAGEMENT: '/product-management',
	CONFIGURATION: "/configuration",
	OPERATIONS: "/operations",
	...productManagement,
	...PATHNAME_CONFIGURATION,
	...PATHNAME_OPERATIONS,
	...sales,
	...purchase,
	...reports,
	SETTING: '/setting'
};